export default __webpack_public_path__ + "static/media/pedigree-image.8fb42f6c.jpg";